// extracted by mini-css-extract-plugin
export default {"banner":"uhCqm6p_VUj6zgppRp5U","text":"kx2wsg4mbBKuLbYIohH8","dismiss":"crl3NlMPKDSL5NxhGTqh"};